import RunStatusIcon from "@features/run/RunStatusIcon"
import { RunRow } from "@features/scenarioDesign/RunTable"
import { MRT_ColumnDef } from "material-react-table"
import { readableRunStatus } from "utils/run"

export const getRunTableColumns = (): MRT_ColumnDef<RunRow>[] => {
  return [
    {
      accessorKey: "scenario_name",
      header: "Name",
      size: 50,
    },
    {
      accessorFn: (runGroup) => (
        <>
          <RunStatusIcon status={runGroup.status} sx={{ mr: 1 }} />
          {readableRunStatus[runGroup.status]}
        </>
      ),
      header: "Status",
      size: 20,
    },
  ]
}
